import { ApiService } from 'app/api';
import { IApplicationContext } from 'app/context/types';
import {
	ILessonTypeConfig,
	INumberCombinationConfig,
	IPronounConfig,
	IRegionConfig,
	ITimeCombinationConfig,
	IUpdateAppPlatformVersion,
	IUpdateLessonTypeConfig,
	IUpdateNumberCombinationConfig,
	IUpdatePronounConfig,
	IUpdateRegionConfig,
	IUpdateTimeCombinationConfig,
} from '../interfaces/appConfig';

export class AppConfigurationService {
	private apiService: ApiService;

	constructor(private applicationContext: IApplicationContext) {
		this.apiService = new ApiService(this.applicationContext);
	}

	getAppConfig() {
		return new Promise((resolve, reject) =>
			this.apiService
				.invoke(
					this.applicationContext.getApiConfig().APP_CONFIGURATION
						.GET_APP_CONFIG,
					{},
				)
				.then(({ data }: any) => {
					resolve(data);
				})
				.catch((err: Error) => {
					reject(err);
				}),
		);
	}

	updateLessonTypeConfig(configs: ILessonTypeConfig) {
		const data: IUpdateLessonTypeConfig = {
			type: configs.type,
			introVideoId: configs.introVideo?.id,
			demoVideoId: configs.demoVideo?.id,
			audioSpeedConfigs: configs.audioSpeedConfigs,
		};
		return new Promise((resolve, reject) =>
			this.apiService
				.invoke(
					this.applicationContext.getApiConfig().APP_CONFIGURATION
						.UPDATE_LESSON_TYPE_CONFIG,
					data,
				)
				.then(({ data }: any) => {
					resolve(data);
				})
				.catch((err: Error) => {
					reject(err);
				}),
		);
	}

	updatePronounConfig(configs: IPronounConfig) {
		const data: IUpdatePronounConfig = {
			pronoun: configs.pronoun,
			imageId: configs.image?.id,
		};
		return new Promise((resolve, reject) =>
			this.apiService
				.invoke(
					this.applicationContext.getApiConfig().APP_CONFIGURATION
						.UPDATE_APP_PRONOUN_CONFIG,
					data,
				)
				.then(({ data }: any) => {
					resolve(data);
				})
				.catch((err: Error) => {
					reject(err);
				}),
		);
	}

	updateRegionConfig(configs: IRegionConfig) {
		const data: IUpdateRegionConfig = {
			...configs,
		};
		return new Promise((resolve, reject) =>
			this.apiService
				.invoke(
					this.applicationContext.getApiConfig().APP_CONFIGURATION
						.UPDATE_REGION_CONFIG,
					data,
				)
				.then(({ data }: any) => {
					resolve(data);
				})
				.catch((err: Error) => {
					reject(err);
				}),
		);
	}

	updateAppPlatformVersionsConfig(configs: IUpdateAppPlatformVersion) {
		return new Promise((resolve, reject) =>
			this.apiService
				.invoke(
					this.applicationContext.getApiConfig().APP_CONFIGURATION
						.UPDATE_PLATFORM_VERSIONS_CONFIG,
					{
						...configs,
					},
				)
				.then(({ data }: any) => {
					resolve(data);
				})
				.catch((err: Error) => {
					reject(err);
				}),
		);
	}

	updateNumberCombinationConfig(configs: INumberCombinationConfig) {
		return new Promise((resolve, reject) =>
			this.apiService
				.invoke(
					this.applicationContext.getApiConfig().APP_CONFIGURATION
						.UPDATE_NUMBER_COMBINATION_CONFIG,
					{
						nameKey: configs.nameKey,
						audioId: configs.audio.id,
					} as IUpdateNumberCombinationConfig,
				)
				.then(({ data }: any) => {
					resolve(data);
				})
				.catch((err: Error) => {
					reject(err);
				}),
		);
	}

	updateTimeCombinationConfig(configs: ITimeCombinationConfig) {
		return new Promise((resolve, reject) =>
			this.apiService
				.invoke(
					this.applicationContext.getApiConfig().APP_CONFIGURATION
						.UPDATE_TIME_COMBINATION_CONFIG,
					{
						nameKey: configs.nameKey,
						audioId: configs.audio.id,
					} as IUpdateTimeCombinationConfig,
				)
				.then(({ data }: any) => {
					resolve(data);
				})
				.catch((err: Error) => {
					reject(err);
				}),
		);
	}
}
